"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _downshift = _interopRequireDefault(require("downshift"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var R = _interopRequireWildcard(require("ramda"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _pluralTranslations = require("../../../../../../localization/pluralTranslations");
var _RenderWhen = _interopRequireDefault(require("../../../../../RenderWhen"));
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _styles = _interopRequireDefault(require("../../../../styles"));
var _selectors = require("../../store/selectors");
var _actions = require("../../store/actions");
var _arrow = _interopRequireDefault(require("./img/arrow.svg"));
var _plane = _interopRequireDefault(require("./img/plane.svg"));
var _bus = _interopRequireDefault(require("./img/bus.svg"));
var _train = _interopRequireDefault(require("./img/train.svg"));
var _walk = _interopRequireDefault(require("./img/walk.svg"));
var _helpers = require("./helpers");
var _styles2 = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledSelectHeader = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :active,\n    :focus,\n    :hover {\n        border-color: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var getTransportIcon = function getTransportIcon(transport) {
  return R.call(R.cond([[R.equals('air'), R.always(_plane.default)], [R.equals('bus'), R.always(_bus.default)], [R.equals('train'), R.always(_train.default)], [R.equals('no'), R.always(_walk.default)], [R.T, R.F]]), transport);
};
var getIconClassBySeats = R.cond([[function (seats) {
  return R.includes(seats, ['yes', 'many', 'yesplace']);
}, R.always(_styles.default.green)], [function (seats) {
  return R.includes(seats, ['request', 'few']);
}, R.always(_styles.default.yellow)], [R.T, R.always(_styles.default.red)]]);
var mapperWithIndex = R.addIndex(R.map);
var DATE_PLACEHOLDER = 'YYYY-MM-DD HH:mm:ss';
var createBinaryNumber = function createBinaryNumber(number) {
  return R.call(R.when(function (v) {
    return R.lt(v, 10);
  }, function (v) {
    return "0".concat(v);
  }), number);
};
var hasDateTime = function hasDateTime(dateAsString) {
  var dateAsMoment = (0, _moment.default)(dateAsString, DATE_PLACEHOLDER);
  return dateAsString !== dateAsMoment.format('YYYY-MM-DD');
};
var getDuration = function getDuration(dateFrom, dateTo) {
  return R.call(R.pipe(function (from, to) {
    return Math.abs(to.diff(from, 'seconds'));
  }, function (seconds) {
    return _moment.default.duration(seconds, 'seconds');
  }, function (duration) {
    return [duration.hours(), createBinaryNumber(duration.minutes())];
  }, R.join(':')), (0, _moment.default)(dateFrom, DATE_PLACEHOLDER), (0, _moment.default)(dateTo, DATE_PLACEHOLDER));
};
var convertDatetoUTC = function convertDatetoUTC(date, timezone) {
  return _momentTimezone.default.tz(date, timezone).utc();
};
var printHourOffset = function printHourOffset(date, timezone) {
  return R.call(R.ifElse(Boolean, function (hours) {
    return "GMT".concat(hours > 0 ? '+' : '').concat(hours);
  }, R.always('')), (0, _moment.default)(date, DATE_PLACEHOLDER).tz(timezone).utcOffset() / 60);
};
var Flight = function Flight(_ref) {
  var active = _ref.active,
    isActual = _ref.isActual,
    isTransportGDS = _ref.isTransportGDS,
    flight = _ref.flight,
    transport = _ref.transport,
    onClick = _ref.onClick;
  var placesTranslation = (0, _pluralTranslations.usePluralPlacesTranslation)();
  var _useTranslation = (0, _reactI18next.useTranslation)(['OFFER_DETAILS', 'AVAILABILLITY_OPTIONS', 'PLACES']),
    t = _useTranslation.t;
  var differentBetweenFromAndToAsDay = (0, _react.useMemo)(function () {
    return (0, _moment.default)(flight.end, DATE_PLACEHOLDER).startOf('day').diff((0, _moment.default)(flight.begin, DATE_PLACEHOLDER).startOf('day'), 'days');
  }, [flight]);
  var durationTime = (0, _react.useMemo)(function () {
    var _flight$portToDetails, _flight$portFrDetails;
    return ((_flight$portToDetails = flight.portToDetails) === null || _flight$portToDetails === void 0 ? void 0 : _flight$portToDetails.timezone) && ((_flight$portFrDetails = flight.portFrDetails) === null || _flight$portFrDetails === void 0 ? void 0 : _flight$portFrDetails.timezone) && hasDateTime(flight.begin) && hasDateTime(flight.end) && getDuration(convertDatetoUTC(flight.begin, flight.portFrDetails.timezone), convertDatetoUTC(flight.end, flight.portToDetails.timezone));
  }, [flight]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.field, _defineProperty({}, _styles2.default.active, active)),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.top
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.transportIcon, _styles2.default[transport], _styles.default.icon),
    dangerouslySetInnerHTML: {
      __html: getTransportIcon(transport)
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.date
  }, (0, _moment.default)(flight.begin, DATE_PLACEHOLDER).format('DD MMM')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.day
  }, (0, _moment.default)(flight.begin, DATE_PLACEHOLDER).format('dd')), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.seats, isActual ? getIconClassBySeats(flight.seats.value) : _styles.default.black)
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
    isTrue: true
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: isTransportGDS
  }, t('SCHEDULED_GDS_FLIGHT')), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: flight.seats.value === 'yesplace'
  }, t('THERE_ARE_PLACES')), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: flight.place > 0
  }, "".concat(flight.place, " ").concat(placesTranslation(flight.place))), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: flight.seats.value === 'request'
  }, t('BY_REQUEST')), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: flight.seats.value === 'no'
  }, t('NO_PLACES'))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.bottom
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.col1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.title
  }, flight.portFr && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.portFr,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.portFr)), ' '), /*#__PURE__*/_react.default.createElement("nobr", null, (0, _helpers.printFlightDate)(flight.begin))), flight.portFrDetails && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.desc)
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.portFrDetails.name,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.portFrDetails.name))), flight.portFrDetails.timezone && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.desc)
  }, printHourOffset(flight.begin, flight.portFrDetails.timezone)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.col2
  }, flight.line && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.title
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.line,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.line))), flight.code && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.desc
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.code,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.code))), flight.craft && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.desc
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.craft,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.craft)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.col3
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.title
  }, flight.portTo && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.portTo,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.portTo)), ' '), /*#__PURE__*/_react.default.createElement("nobr", null, (0, _helpers.printFlightDate)(flight.end)), Boolean(differentBetweenFromAndToAsDay) && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('DIFFERENT_BETWEEN_FROM_AND_TO_AS_DAY_INFO'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.nextDay
  }, "+".concat(differentBetweenFromAndToAsDay)))), flight.portToDetails && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.desc
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: flight.portToDetails.name,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.overflow
  }, flight.portToDetails.name))), flight.portToDetails.timezone && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.desc, _styles2.default.withDuration)
  }, printHourOffset(flight.end, flight.portToDetails.timezone), ' ', "\xA0", durationTime && /*#__PURE__*/_react.default.createElement("nobr", null, t('FLIGHT_DURATION_INFO', {
    duration: durationTime
  })))))));
};
Flight.defaultProps = {
  isActual: true
};
var Transport = function Transport(_ref2) {
  var activeFlight = _ref2.activeFlight,
    className = _ref2.className,
    isTransportGDS = _ref2.isTransportGDS,
    flights = _ref2.flights,
    isActual = _ref2.isActual,
    transport = _ref2.transport,
    onChange = _ref2.onChange;
  return /*#__PURE__*/_react.default.createElement(_downshift.default, {
    onOpen: R.always
  }, function (_ref3) {
    var closeMenu = _ref3.closeMenu,
      isOpen = _ref3.isOpen,
      getToggleButtonProps = _ref3.getToggleButtonProps,
      getRootProps = _ref3.getRootProps;
    return /*#__PURE__*/_react.default.createElement(StyledSelectHeader, _extends({
      className: (0, _classnames4.default)(_styles2.default.dropdownContainer, className, _defineProperty(_defineProperty({}, _styles2.default.hasDropdown, flights.length > 1), _styles2.default.active, isOpen))
    }, getRootProps()), /*#__PURE__*/_react.default.createElement("div", _extends({
      className: (0, _classnames4.default)(_styles2.default.fieldContainer, _defineProperty({}, _styles2.default.active, isOpen))
    }, getToggleButtonProps({
      disabled: flights.length === 1
    })), activeFlight && /*#__PURE__*/_react.default.createElement(Flight, {
      isActual: isActual,
      isTransportGDS: isTransportGDS,
      flight: activeFlight,
      transport: transport
    }), flights.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.arrowIcon,
      dangerouslySetInnerHTML: {
        __html: _arrow.default
      }
    })), isOpen && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.dropdown
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.list
    }, mapperWithIndex(function (flight, index) {
      return /*#__PURE__*/_react.default.createElement(Flight, {
        active: flight === activeFlight,
        isActual: isActual,
        isTransportGDS: isTransportGDS,
        flight: flight,
        key: index,
        transport: transport,
        onClick: function onClick() {
          if (onChange) {
            onChange(flight);
          }
          closeMenu();
        }
      });
    }, flights))));
  });
};
var flightPropsType = _propTypes.default.shape({
  line: _propTypes.default.string,
  place: _propTypes.default.string,
  begin: _propTypes.default.string,
  portFr: _propTypes.default.string,
  portTo: _propTypes.default.string,
  seats: _propTypes.default.shape({
    value: _propTypes.default.string
  })
});
Transport.propTypes = {
  className: _propTypes.default.oneOf([_styles2.default.inbound, _styles2.default.outbound]).isRequired,
  activeFlight: flightPropsType,
  flights: _propTypes.default.arrayOf(flightPropsType).isRequired,
  onChange: _propTypes.default.func
};
var TransportMemoized = (0, _react.memo)(Transport);
var Transports = function Transports(_ref4) {
  var flights = _ref4.flights,
    nights = _ref4.nights,
    isActual = _ref4.isActual,
    isTransportGDS = _ref4.isTransportGDS,
    transport = _ref4.transport,
    startDate = _ref4.startDate;
  var dateFrom = (0, _moment.default)(startDate, 'YYYY-MM-DD').startOf('day');
  var dateTo = dateFrom.clone().add(nights, 'days');
  var dispatch = (0, _reactRedux.useDispatch)();
  var activeFlights = (0, _reactRedux.useSelector)(_selectors.getActiveFlights);
  var onChangeOutboundFlight = (0, _react.useCallback)(function (flight) {
    return dispatch((0, _actions.setActiveOutboundFlight)(flight));
  }, [dispatch]);
  var onChangeInboundFlight = (0, _react.useCallback)(function (flight) {
    return dispatch((0, _actions.setActiveInboundFlight)(flight));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.flights
  }, R.isEmpty(flights.outbound) ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.offerDateTitle
  }, dateFrom.format('DD MMM'), ' ', /*#__PURE__*/_react.default.createElement("span", null, dateFrom.format('dd'))) : /*#__PURE__*/_react.default.createElement(TransportMemoized, {
    activeFlight: activeFlights.outbound,
    className: _styles2.default.outbound,
    isTransportGDS: isTransportGDS,
    flights: flights.outbound,
    isActual: isActual,
    transport: transport,
    onChange: onChangeOutboundFlight
  }), R.isEmpty(flights.inbound) ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.offerDateTitle
  }, dateTo.format('DD MMM'), ' ', /*#__PURE__*/_react.default.createElement("span", null, dateTo.format('dd'))) : /*#__PURE__*/_react.default.createElement(TransportMemoized, {
    activeFlight: activeFlights.inbound,
    className: _styles2.default.inbound,
    isTransportGDS: isTransportGDS,
    flights: flights.inbound,
    isActual: isActual,
    transport: transport,
    onChange: onChangeInboundFlight
  })));
};
Transports.propTypes = {
  activeFlight: flightPropsType,
  isTransportGDS: _propTypes.default.bool,
  nights: _propTypes.default.number.isRequired,
  startDate: _propTypes.default.string.isRequired,
  transport: _propTypes.default.string.isRequired,
  flights: _propTypes.default.shape({
    outbound: _propTypes.default.array.isRequired,
    inbound: _propTypes.default.array.isRequired
  }),
  isActual: _propTypes.default.bool
};
Transports.defaultProps = {
  isActual: true
};
var _default = exports.default = (0, _react.memo)(Transports);